export default __webpack_public_path__ + "static/media/bgLogin.58d8b018.jpg";